import {FETCH_UPCOMING_SCHEDULE} from '../actions/types';

const INTIAL_STATE = [];

export default (state = INTIAL_STATE,action) => {
    switch(action.type){
        case FETCH_UPCOMING_SCHEDULE:
            return action.payload;
        default:
            return state;
    }
}